import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportForm from '../ReportForm';

const CreditMaproReport: React.FC = () => {
    const { t } = useTranslation();

    return (
        <ReportForm
            title={t('reports.CreditMaproReport.title')}
            serviceName="customReportsService"
            APIName="getCreditMaproReport"
            savedFileName={t('reports.CreditMaproReport.title')}
        />
    );
};

export default CreditMaproReport;
